/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import CameraAnimator from "App/animations/camera_animator";

export default
class AnimatedObject {
    private static animatedObjectUID: number = 0;
    private _AUID: number = AnimatedObject.animatedObjectUID++;
    protected _deviceInputEnabled: boolean = false;
    private _animators: CameraAnimator[] = [];

    /***
     * Return animation object UID
     * @returns {number|*} the unique animation object id
     */
    public getAUID(): number {
        return this._AUID;
    }

    public setEnableDeviceInput(aValue: boolean, aKeepViewDirection: boolean): void {
        this._deviceInputEnabled = aValue;
    }

    public getDeviceInputEnabled(): boolean {
        return this._deviceInputEnabled;
    }

    public attachAnimator(aAnimator: CameraAnimator) {
        this._animators.push(aAnimator);
    }

    public removeAnimator(aAnimator: CameraAnimator) {
        let index = this._animators.indexOf(aAnimator);
        if (index >= 0) {
            this._animators.splice(index, 1);
        }
    }

    public containsAnimator(aAnimator: CameraAnimator): boolean {
        return this._animators.indexOf(aAnimator) >= 0;
    }

    public animationTick() {
        let finished = [];
        for (let i in this._animators) {
            let animator = this._animators[i];
            animator.animationTick();

            if (animator.getAnimationFinished()) {
                animator.finishAnimation();
                finished.push(i);
            }
        }

        for (let j in finished) {
            let index = finished[j];
            this._animators.splice(index, 1);
        }
    }

    public isEmpty(): boolean {
        return this._animators.length === 0;
    }

    public animate(aAnimator: CameraAnimator, aTimeFactor: number) {
    }
}
